var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_457)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0C19.404 0 25 5.59595 25 12.5C25 19.404 19.404 25 12.5 25C5.59595 25 0 19.404 0 12.5C0 5.59595 5.59595 0 12.5 0Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86999 12.5L6.87901 15.8053L9.6875 17.458V19.3931L5.23538 16.7819V11.5335L6.86999 12.5ZM6.86999 9.19474V11.1208L5.23438 10.1533V8.22719L6.86999 7.25964L8.51362 8.22719L6.86999 9.19474ZM10.8604 8.22719L12.496 7.25964L14.1396 8.22719L12.496 9.19474L10.8604 8.22719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05188 15.1202V13.1851L9.6875 14.1527V16.0788L8.05188 15.1202ZM10.8604 18.1511L12.496 19.1186L14.1396 18.1511V20.0772L12.496 21.0447L10.8604 20.0772V18.1511ZM16.4854 8.22719L18.121 7.25964L19.7646 8.22719V10.1533L18.121 11.1208V9.19474L16.4854 8.22719ZM18.121 15.8053L18.13 12.5L19.7656 11.5325V16.7809L15.3135 19.3921V17.457L18.121 15.8053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9481 15.1202L15.3125 16.0787V14.1526L16.9481 13.1851V15.1202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9481 9.8798L16.9571 11.8149L14.1406 13.4675V16.7808L12.505 17.7394L10.8694 16.7808V13.4675L8.05288 11.8149V9.8798L9.69551 8.91225L12.495 10.5729L15.3115 8.91225L16.9551 9.8798H16.9481ZM8.05188 6.57551L12.496 3.95532L16.9481 6.57551L15.3125 7.54306L12.496 5.88241L9.6875 7.54306L8.05188 6.57551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.dbdbddc71a51c1c7c36203cae0316817.svg";
export { ForwardRef as ReactComponent };